export default "__VITE_ASSET__Tk9xRe4$__"